// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".my-title>span[data-v-16b2126e]{font-size:14px;font-weight:700;float:left}.my-title .extra[data-v-16b2126e]{float:left;margin-left:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
